import type { AdminWorkspace, WorkspaceStatus } from "./types";

/** The API derives the lifecycle status (pending, active, suspended, deleted) and sends it. */
export function workspaceStatus(workspace: Pick<AdminWorkspace, "status">): WorkspaceStatus {
  return workspace.status;
}
